import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Sound extends Component {
	componentDidMount() {
		const {
			sound,
			options,
			on_complete,
		} = this.props;

		this._sound = window.createjs.Sound.play(sound, options);
		if (on_complete) {
			this._sound.on('complete', on_complete);
		}
	}
	componentWillUnmount() {
		this._sound && this._sound.stop();
	}
	render() {
		return null;
	}
}
Sound.propTypes = {
	sound: PropTypes.string.isRequired,
	options: PropTypes.object,
	on_complete: PropTypes.func,
};
Sound.defaultProps = {
	options: {},
};
export default Sound;


// WEBPACK FOOTER //
// ./src/Sound.js